import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { FC } from 'react'
import QuestionCircleIcon from '../../../../assets/icons/QuestionCircle.svg?react'

type Props = {
    title: string
    description?: string
}

export const SettingFormItemLabel: FC<Props> = ({ title, description }) => (
    <Stack display="block" sx={{ alignItems: 'center', mb: 1 }}>
        <Typography
            variant="h5"
            sx={{
                color: '#121317',
                display: 'contents',
            }}>
            {title}
        </Typography>
        {description && (
            <Tooltip title={description}>
                <IconButton>
                    <QuestionCircleIcon />
                </IconButton>
            </Tooltip>
        )}
    </Stack>
)
